module.exports = __webpack_public_path__ + "static/media/logo.dc0935bc.webp";